import { ORDER_METHODS, RoomServiceLocationType } from '../../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ROOM_SERVICE]: {
      [RoomServiceLocationType.RoomService]: 'På stedet',
      [RoomServiceLocationType.TableService]: 'På stedet',
      both: 'På stedet',
    },
    [ORDER_METHODS.PICKUP]: 'Afhentning',
    [ORDER_METHODS.DELIVERY]: 'Levering',
  },
};
